(function () {
  'use strict';

  if (window.__peakLoveMobileMenu) return;
  window.__peakLoveMobileMenu = true;

  var MOBILE_QUERY = '(max-width: 991px)';

  var hamburger = null;
  var menuLinks = null;
  var menuItems = [];
  var isOpen = false;
  var tl = null;
  var initialized = false;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMq = window.matchMedia(MOBILE_QUERY);

  function isMobile() {
    return mobileMq.matches;
  }

  function setClosedState() {
    gsap.set(menuLinks, {
      y: '-100%',
      rotation: 0,
      transformOrigin: 'top top',
    });
    gsap.set(menuItems, {
      opacity: 0,
      y: 24,
    });
  }

  function clearInlineStyles() {
    gsap.set([menuLinks].concat(menuItems), { clearProps: 'all' });
  }

  function buildTimeline() {
    tl = gsap.timeline({
      paused: true,
      defaults: { ease: 'power3.out' },
      onStart: function () {
        menuLinks.classList.add('open');
        hamburger.classList.add('open');
        hamburger.setAttribute('aria-expanded', 'true');
      },
      onReverseComplete: function () {
        menuLinks.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        isOpen = false;
        collapseHouseSub();
      },
    });

    tl.to(menuLinks, {
      y: '0%',
      rotation: 0,
      duration: prefersReducedMotion ? 0 : 0.65,
    }).to(
      menuItems,
      {
        opacity: 1,
        y: 0,
        duration: prefersReducedMotion ? 0 : 0.45,
        stagger: prefersReducedMotion ? 0 : 0.08,
        ease: 'power2.out',
      },
      prefersReducedMotion ? 0 : '-=0.25'
    );
  }

  function setupMobile() {
    if (initialized) return;
    setClosedState();
    buildTimeline();
    initialized = true;
  }

  function collapseHouseSub() {
    if (!menuLinks) return;
    var houseItem = menuLinks.querySelector('.has-house-menu');
    if (!houseItem) return;
    houseItem.classList.remove('is-open');
    var houseTrigger = houseItem.querySelector('a.main-nav');
    if (houseTrigger) houseTrigger.setAttribute('aria-expanded', 'false');
  }

  function teardownMobile() {
    if (!initialized) return;
    if (isOpen && tl) {
      tl.progress(0).pause();
      menuLinks.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      isOpen = false;
    }
    collapseHouseSub();
    clearInlineStyles();
    tl = null;
    initialized = false;
  }

  function openMenu() {
    if (!isMobile() || isOpen || !tl) return;
    isOpen = true;
    tl.timeScale(1).play();
  }

  function closeMenu() {
    if (!isOpen || !tl) return;
    tl.timeScale(2).reverse();
  }

  function onDocumentClick(e) {
    if (!isOpen) return;
    if (menuLinks.contains(e.target) || hamburger.contains(e.target)) return;
    closeMenu();
  }

  function onKeydown(e) {
    if (!isOpen || e.key !== 'Escape') return;
    closeMenu();
  }

  function toggleMenu() {
    if (!isMobile()) return;
    if (isOpen) closeMenu();
    else openMenu();
  }

  function onBreakpointChange() {
    if (isMobile()) setupMobile();
    else teardownMobile();
  }

  function init() {
    if (typeof gsap === 'undefined') return;

    hamburger = document.querySelector('.site-header .hamburger');
    menuLinks = document.querySelector('.site-header .menu-links');
    if (!hamburger || !menuLinks) return;

    menuItems = gsap.utils.toArray('.site-header .menu-links > li');

    hamburger.addEventListener('click', toggleMenu);

    menuLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (link.matches('.has-house-menu > a.main-nav')) return;
        closeMenu();
      });
    });

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);

    mobileMq.addEventListener('change', onBreakpointChange);

    if (isMobile()) setupMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MobileMenu = {
    open: openMenu,
    close: closeMenu,
    toggle: toggleMenu,
  };
})();
